import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, URL } from '../../variables';
import { maskCnpj, maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';


import { TextField } from '@material-ui/core';
import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles';
import PasswordInput from '../ReusableComponents/PasswordInput';
import { RadioGroup } from '@mui/material';
import { FormControlLabel, Radio } from '@material-ui/core';
class CriarOrganizadora extends Component {static contextType = PreferencesContext;

  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      path: '/',
      loading_screen: false,
      roles: [],
      name: '',
      email: '',
      password: '',
      password_confirmation: '',
      random_password: true,
      loading_save: false,
      msgErro: '',
      loading_image: false,
      faculdade: { name: '' },
      descricao: '',
      cnpj: '',
      name_organizadora: ''
    };


  }

  get_faculdade(id) {

    if (this.state.loading_screen == false) {
      this.setState({ loading_screen: true });
    }
    fetch(`${URL}api/faculdade/get_faculdade/${id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.message == "Unauthenticated.") {
          localStorage.removeItem('token');localStorage.removeItem('user');
          // this.setState({redirect:true,path:'/'});
          this.props.logout();
          return;
        }
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          this.setState({ redirect: true });

          //   setTimeout(()=>{
          //     this.get_processo();
          //   });
        } else
        {
          // this.props.mudarUser(resp.user);
          this.setState({
            loading_screen: false, faculdade: resp.faculdade
          });
          // if (resp.processo != null) {


        }




      } catch (err) {
        this.setState({ redirect: true });
        console.log(err);


      }

    }).
    catch((err) => {
      this.setState({ redirect: true });

      console.log(err);
      // this.props.mudarLoadingHome(false);
    });
  }



  salvar(e) {
    e.preventDefault();
    this.setState({ loading_save: true, msgErro: '' });
    let form = new FormData();
    let data = {
      name_organizadora: this.state.name_organizadora,
      descricao: this.state.descricao,
      cnpj: this.state.cnpj,
      name: this.state.name,
      email: this.state.email,
      password: this.state.password,
      password_confirmation: this.state.password_confirmation,
      random_password: this.state.random_password
    };





    fetch(`${URL}api/faculdade/store_organizadora`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${this.props.token}`,
        'Content-type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
            erro += errors[i] + '\n';else

            erro += errors[i];
          }
          console.log(erro);
          window.scrollTo(500, 0);

          this.setState({ loading_save: false, msgErro: erro });
        } else
        {

          this.setState({ loading_save: false });
          this.props.history.push({
            pathname: `/organizadoras`,

            search: '?' + new URLSearchParams({ tab: '1' }).toString()
          });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor' });

      }

    }).
    catch((err) => {
      console.log(err);
      this.setState({ loading_save: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
    });
  }


  componentDidMount() {



    // this.get_faculdade(this.props.match.params.id);
  }


  change_tipo(event) {
    this.setState({ tipo: event.target.value });
  }


  render() {
    return (
      <div className="row">
                {this.state.redirect == true && <Redirect to={`/organizadoras`} />}

                <div className="col-12">
                    <div className="card">
                        <div className="card-body" id="card">


                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{this.context.t("ui_cadastrar_organizadora_6386ed45")}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Cadastre suas organizadoras no sistema</p>
                            <br />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <h5 style={{ fontWeight: 'bold' }}>Dados Organizadora</h5>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("legacy_nome_da_organizadora")}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_nome_da_organizadora")}
                        value={this.state.name_organizadora}
                        onChange={(e) => this.setState({ name_organizadora: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>



                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_description")}  `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("label_description")}
                        value={this.state.descricao}
                        onChange={(e) => this.setState({ descricao: e.target.value })}
                        required
                        as="textarea" />

                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("legacy_cnpj")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_cnpj")}
                        value={this.state.cnpj}
                        onChange={(e) => this.setState({ cnpj: maskCnpj(e.target.value) })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>
                                    <br />
                                    <h5 style={{ fontWeight: 'bold' }}>{this.context.t("ui_dados_do_usuario_549a26c8")}</h5>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_name")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("legacy_nome_da_organizadora")}
                        value={this.state.name}
                        onChange={(e) => this.setState({ name: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_email")} `}<Attention /></Form.Label>
                                            <Input
                        placeholder={this.context.t("label_email")}
                        value={this.state.email}
                        onChange={(e) => this.setState({ email: e.target.value })}
                        required
                        // title="Coloque o nome completo do usuário"
                      />
                                        </div>
                                    </InputGroup>

                                    {<InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("legacy_enviar_e_mail_para_o_cliente_com_senha_aleatoria")} `}<Attention /></Form.Label>
                                            <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        name="radio-buttons-group"
                        value={this.state.random_password}
                        onChange={(e) => {
                          this.setState({ random_password: e.target.value });
                        }}>

                                                <FormControlLabel onClick={(e) => {
                          this.setState({ random_password: true });
                        }} control={<Radio checked={this.state.random_password == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {
                          console.log(e.target.value);
                          this.setState({ random_password: false });

                        }} control={<Radio checked={this.state.random_password == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}

                                    {this.state.random_password == false && <>
                                    <InputGroup>
                                        <PasswordInput
                        label={this.context.t("password")}
                        placeholder={this.context.t("placeholder_password")}
                        className="flex1"
                        value={this.state.password}
                        OnChangeText={(e) => this.setState({ password: e.target.value })}
                        required
                        // title="Coloque a senha do usuário"
                      />
                                    </InputGroup>

                                    <InputGroup>
                                        <PasswordInput
                        label={this.context.t("label_password_confirmation")}
                        placeholder={this.context.t("legacy_digite_a_confirmacao_de_senha")}
                        className="flex1"
                        value={this.state.password_confirmation}
                        OnChangeText={(e) => this.setState({ password_confirmation: e.target.value })}
                        required
                        // title="Coloque a senha do usuário"
                      />
                                    </InputGroup>
                                    </>}


                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                      <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                      </Link> */}
                                        <DefaultButton
                      bg="secondary"
                      text={this.context.t("back")}
                      icon={<RiArrowGoBackLine />}
                      search={'?' + new URLSearchParams({ tab: 1 }).toString()}
                      to={`/organizadoras`} />

                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                      {this.state.loading ? <Spinner /> : ""}
                      Registrar usuário
                      </Button> */}
                                        <DefaultButton
                      type="submit"
                      bg="confirm"
                      text={this.context.t("legacy_salvar_organizadora")}
                      disabled={this.state.loading_image == true}
                      loadingtext="Salvando organizadora"
                      loading={this.state.loading_save} />

                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                                        <div className="spinner-border text-primary" role="status">
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status">
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>
            </div>);

  }


}
const mapsStateToProps = (state) => (
{
  token: state.AppReducer.token
});


export default connect(mapsStateToProps, { logout })(CriarOrganizadora);